import Grid from '@mui/material/GridLegacy'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { Form, Field, FormSpy } from 'react-final-form'
import { useEffect, useState } from 'react'
import { isDefined, validEmail, validPostcode } from '../../config/helpers'
import CacheFactory from '../../Factories/CacheFactory'
import contactActions from '../../Redux/Contact/actions'
import { useDispatch, useSelector } from 'react-redux'
import SendIcon from '@mui/icons-material/Send';

const ContactForm = ({
    gridProps = {
        xs: 12,
        md: 6
    },
    message = true,
    postcode = true,
    brochure = false

}) => {


    const dispatch = useDispatch();


    const source = "contact_page";
    const { global_settings, brand } = useSelector((state) => state.globalReducer);
    const { user_agent, ip, token } = useSelector((state) => state.userReducer);
    const { userJourney } = useSelector((state) => state.userjourneyReducer);
    const { contactLoaders, contactMessage } = useSelector((state) => state.contactReducer);
    // const { global_settings } = useSelector((state) => state.contactReducer);

    const [event, setEvent] = useState(null);

    const [numbers, setNumbers] = useState({
        firstNumber: 5,
        secondNumber: 2
    })

    useEffect(() => {
        let randomNumbers = {};
        if (!isDefined(CacheFactory.get('firstNumber'))) {
            randomNumbers.firstNumber = Math.floor((Math.random() * 10) + 1)
            CacheFactory.put('firstNumber', randomNumbers.firstNumber);
        }

        if (!isDefined(CacheFactory.get('secondNumber'))) {
            randomNumbers.secondNumber = Math.floor((Math.random() * 10) + 1)
            CacheFactory.put('secondNumber', randomNumbers.secondNumber);
        }


        randomNumbers = {
            firstNumber: CacheFactory.get('firstNumber'),
            secondNumber: CacheFactory.get('secondNumber'),
        }

        setNumbers(randomNumbers)

    }, [])

    //check if the event is set in the state and if a contact message has been set
    //if all true, reset the form values and reset the event.
    useEffect(() => {
        if (isDefined(event) && isDefined(contactMessage) && contactMessage.sent && contactMessage.status == "success") {
            event.restart();
            setEvent(null);
            if (typeof window !== 'undefined' && window?.gtag && typeof window.gtag != 'undefined') {
                if (process.env.NEXT_PUBLIC_APP_ENV != 'local') {
                    window.gtag('event', 'page_view', { page_location: `${process.env.NEXT_PUBLIC_HOME_URL}/contact.html` });
                }
            }
            // window.ga('send', 'pageview', {page: '/contact.html'});
        }
    }, [event, contactMessage])


    const onSubmit = (async (values, e) => {
        const formData = {
            name: values.name,
            company: values.company,
            telephone: values.telephone,
            email: values.email,
            message: !message ? `${values.name} has submitted a brochure request` : values.message,
            postcode: values.postcode,
            username: '',
            'ip': ip,
            'token': token,
            'user-agent': user_agent,
            'brand': brand.brand_key,
            'user-journey-id': userJourney['user-journey-id'], //TODO: when user journey is introduced
            'came-from': userJourney['came-from'],
            'utm-campaign': userJourney['utm-campaign'],
            'utm-medium': userJourney['utm-medium'],
            'utm-source': userJourney['utm-source'],
            isBrochure: brochure
        }




        dispatch({
            type: contactActions.CONTACT_SEND_MESSAGE,
            payload: { form: formData, source: source }
        })


        setEvent(e);
    })


    const renderTextField = (
        { input, label, meta: { touched, invalid, error }, ...custom },
    ) => (
        <>
            <TextField
                helperText={touched && invalid && error}
                error={touched && invalid ? true : false}
                {...input}
                {...custom}
                label={custom.placeholder}
                className="w-100"
            />

        </>
    );


    const renderTextAreaField = (
        { input, label, meta: { touched, invalid, error }, ...custom },
    ) => (
        <>
            <TextField
                helperText={touched && invalid && error}
                error={touched && invalid ? true : false}
                {...input}
                {...custom}
                label={custom.placeholder}
                multiline
                rows={2}
                className="w-100"
            />

        </>
    );



    return (
        <Box>
            <Form
                name="my-form"
                validate={values => {
                    const requiredFields = ['email', 'telephone', 'name', 'capcha'];
                    if (message) {
                        requiredFields.push('message')
                    }
                    if (postcode) {
                        requiredFields.push('postcode')
                    }
                    const errors = {}
                    if (values.username) {
                        console.log({
                            username: values.username,
                            len: values.username.length
                        })
                        if (values.username.length > 0) {
                            errors.username = 'Please enter a valid username.'
                        }
                    }
                    const requiredMessage = 'This field is required.'
                    Object.values(requiredFields).forEach((entry) => {
                        //empty value on required field
                        if (!values[entry]) {
                            errors[entry] = requiredMessage;
                        }
                        //capcha validation
                        else if (entry == 'capcha') {
                            if (values[entry] != (numbers.firstNumber) + (numbers.secondNumber)) {
                                errors[entry] = "Wrong answer, try again."
                            }
                        }
                        //postcode validation
                        else if (entry == 'postcode') {
                            if (validPostcode(values[entry]) == false) {
                                errors[entry] = 'Please enter a valid postcode.'
                            }
                        }
                        //email validation
                        else if (entry == 'email') {
                            if (!validEmail(values[entry]) == true) {
                                errors[entry] = 'Please enter a valid email address.'
                            }
                        }

                    })
                    return errors
                }}
                onSubmit={onSubmit}
                render={({ form, handleSubmit, submitting, pristine, values }) => (
                    <>
                        <form id="contactus-form">

                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item {...gridProps}>
                                    <Field
                                        name="name"
                                        component={renderTextField}
                                        placeholder="Name"
                                        label="Name"
                                    />
                                </Grid>
                                <Grid item {...gridProps}>
                                    <Field
                                        name="company"
                                        component={renderTextField}
                                        placeholder="Company"
                                        label="Company"
                                    />
                                </Grid>
                                <Grid item {...gridProps}>
                                    <Field
                                        name="telephone"
                                        component={renderTextField}
                                        placeholder="Telephone"
                                        label="Telephone"
                                    />
                                </Grid>
                                <Grid item {...gridProps}>
                                    <Field
                                        name="email"
                                        component={renderTextField}
                                        placeholder="E-mail"
                                        label="E-mail"
                                    />
                                </Grid>
                                {message && (
                                    <Grid item xs={12}>
                                        <Field
                                            name="message"
                                            component={renderTextAreaField}
                                            placeholder="Message"
                                            label="Message"
                                        />
                                    </Grid>
                                )}
                                {postcode && (
                                    <Grid item xs={12}>
                                        <Field
                                            name="postcode"
                                            component={renderTextField}
                                            placeholder="Postcode"
                                            label="Postcode"
                                        />
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Field
                                        name="capcha"
                                        component={renderTextField}
                                        placeholder={`${numbers.firstNumber} + ${numbers.secondNumber}? (Are you human?)`}
                                        label={`${numbers.firstNumber} + ${numbers.secondNumber}? (Are you human?)`}
                                    />
                                </Grid>
                                <Grid item xs={12} className="d-none">
                                    <Field
                                        name="username"
                                        component={renderTextField}
                                        placeholder="Username"
                                        label="Username"
                                        type={"hidden"}
                                    />
                                </Grid>
                            </Grid>

                            <Button
                                className="f-left mt-4 mr-2"
                                variant="contained"
                                color="primary"
                                onClick={form.submit}
                                endIcon={<SendIcon />}
                                loading={contactLoaders.submitContactForm}
                            >
                                Submit
                            </Button>

                            <Button className="f-left mt-4" onClick={form.restart} variant="outlined">Clear</Button>
                        </form>
                    </>
                )}
            />
        </Box>
    )
}

export default ContactForm